<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:class="modalSize"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_product_name" class="col-sm-3 mb-0">
						Product Name
					</label>
					<app-input
						id="inputs_product_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.product_name"
						placeholder="Product Name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_class_name" class="col-sm-3 mb-0">
						Class Name
					</label>
					<app-input
						id="inputs_class_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.class_name"
						placeholder="Class Name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_mon" class="col-sm-3 mb-0"> Mon </label>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.mon_start"
						placeholder="Start Time"
						:required="true"
					/>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.mon_end"
						placeholder="End Time"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_tue" class="col-sm-3 mb-0"> Tue </label>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.tue_start"
						placeholder="Start Time"
						:required="true"
					/>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.tue_end"
						placeholder="End Time"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_wed" class="col-sm-3 mb-0"> Wed </label>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.wed_start"
						placeholder="Start Time"
						:required="true"
					/>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.wed_end"
						placeholder="End Time"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_thu" class="col-sm-3 mb-0"> Thu </label>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.thu_start"
						placeholder="Start Time"
						:required="true"
					/>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.thu_end"
						placeholder="End Time"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_fri" class="col-sm-3 mb-0"> Fri </label>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.fri_start"
						placeholder="Start Time"
						:required="true"
					/>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.fri_end"
						placeholder="End Time"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sat" class="col-sm-3 mb-0"> Sat </label>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.sat_start"
						placeholder="Start Time"
						:required="true"
					/>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.sat_end"
						placeholder="End Time"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_start_date" class="col-sm-3 mb-0">
						Start Date
					</label>
					<app-input
						id="inputs_start_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.name"
						placeholder="Start Date"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_clc_date" class="col-sm-3 mb-0">
						CLC Calendar
					</label>
					<app-input
						id="inputs_clc_date"
						class="col-sm-9"
						type="text"
						v-model="inputs.clc_date"
						placeholder="CLC Calendar"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_note" class="col-sm-3 mb-0">
						Note
					</label>
					<app-input
						id="inputs_note"
						class="col-sm-9"
						type="date"
						v-model="inputs.note"
						placeholder="Note"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "ScheduleRecommendationTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {
				product_name: "",
				class_name: "",
				mon_start: "",
				mon_end: "",
				tue_start: "",
				tue_end: "",
				wed_start: "",
				wed_end: "",
				thu_start: "",
				thu_end: "",
				fri_start: "",
				fri_end: "",
				sat_start: "",
				sat_end: "",
				start_date: "",
				clc_date: "",
				note: "",
			},
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
			modalSize: "fullscreen",
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
